import { render } from "./Customer.vue?vue&type=template&id=030f42c8&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=030f42c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030f42c8"]])

export default __exports__